export const uuid = () => 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/x/g, () => {
  const r = Math.floor(Math.random() * 16);
  return r.toString(16);
});
